import canBeRichEdited from '../../../../constraints/verifiers/can-be-rich-edited';
import getAdvancedSelection from '../../../../text-formatting/accessors/get-advanced-selection';
import { NBSP_STRING } from '../../../../content-editable/constants/common';
import { ENTER_KEY } from '../../../../content-editable/constants/keys';

/**
 * This Firefox workaround helper uses setTimeout to handle the situation
 * when editable element become empty on 'delete' key pressed even after
 * a whitespace has been previously inserted via some another
 * requestAnimationFrame-based helper. This is possible, because rAF does
 * not guarantee that whitespace insertion will be performed after the
 * browser deletes editable character in response to keydown event.
 * For a some reason this periodically become an issue in Firefox.
 * */

let timeout;

function handleEmptyEditableElement(event) {
  clearTimeout(timeout);

  const { srcElement, key } = event;
  const { ownerDocument: liveDocument } = srcElement;
  const isSrcElementNotEditable =
    !canBeRichEdited(srcElement) && !srcElement.hasAttribute('contenteditable');

  if (isSrcElementNotEditable) return;

  timeout = setTimeout(() => {
    // Allow line breaks in empty elements
    if (key === ENTER_KEY) return;

    if (srcElement.innerText.trim()) return;

    const hasChildElements = Boolean(srcElement.children && srcElement.children.length);
    if (hasChildElements) return;

    const selection = getAdvancedSelection();
    const nodeWithSpace = liveDocument.createTextNode(NBSP_STRING);

    srcElement.innerHTML = '';
    srcElement.appendChild(nodeWithSpace);
    selection.collapse(srcElement, 0);
  });
}

export default handleEmptyEditableElement;
